import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { ListItem } from '../../../../models/api/core/list/list-item';
import { BaseComponent } from '../../../base/base.component';
import { SelectOptionComponent } from './select-option.component';

@Component({
  selector: 'app-claim-type-option',
  imports: [SelectOptionComponent],
  template: `
    <app-select-option
      label="The claim type is"
      [control]="control"
      [showList]="true"
      [listControl]="listControl"
      [items]="alerts.claimTypes"
      [multiple]="true"
      [filter]="false"
      [maxSelectedLabels]="3"
      [listControlRequired]="true"
    />
  `,
  styles: ``,
})
export class ClaimTypeOptionComponent extends BaseComponent implements OnInit {
  alerts = inject(AlertsService);

  @Input()
  listControl: FormControl<any>;

  @Input()
  control: FormControl<any[]>;

  claimTypes: ListItem[];

  async ngOnInit() {
    /*     const listResponse = await this.api.list.get();
    this.claimTypes = listResponse.claimTypes; */
    if (this.listControl.value == null) {
      this.listControl.setValue(
        this.alerts.find(this.alerts.listItems, 'InList'),
      );
    }

    this.control.addValidators([Validators.required]);
    if (this.control.value == null) {
      this.control.setValue([]);
    }
  }
}
